import React, { useState } from "react";
import {
  firstDayOfMonth,
  getEndOfDayFromDate,
  getStartOfDayFromDate,
  lastDayOfMonth,
  TimestampToDate
} from "../../../../utils/timestampToDate";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import { StyledDatepicker } from "../../../styles/styledDatepicker";
import DatePicker from "../../../elements/datePicker/DatePicker";
import { useTranslation } from "react-i18next";

const CashFlowProfitFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("cashFlow");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currency": null,
    "paymentSystem": null,
    "service": null,
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {

    if (filterData["currentTab"]) {
      DEFAULT_FILTER_DATA.currentTab = filterData["currentTab"];
    }

    DEFAULT_FILTER_DATA["dateFrom"] = firstDayOfMonth();
    DEFAULT_FILTER_DATA["dateTo"] = lastDayOfMonth();

    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("profit.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("profit.filter.paymentMethods")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <MappedServicesFilter
                checkedService={filterData["service"]}
                setCheckedService={data => handleChangeFilterData(data, "service")}

                checkedPaymentSystem={filterData["paymentSystem"]}
                setCheckedPaymentSystem={data => handleChangeFilterData(data, "paymentSystem")}

                checkedCurrency={filterData["currency"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "currency")}
              />
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("profit.filter.date")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <StyledDatepicker>
                <label htmlFor="dateFrom">
                  {t("profit.filter.dateFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateFrom"
                  name="dateFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "dateFrom": getStartOfDayFromDate(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["dateFrom"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="dateTo">
                  {t("profit.filter.dateTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateTo"
                  name="dateTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "dateTo": getEndOfDayFromDate(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["dateTo"])}
                />
              </StyledDatepicker>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("profit.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default CashFlowProfitFilter;